export default __webpack_public_path__ + "static/media/about_img.63d19478.png";